import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Radio from './Radio';
import RadioGroup from './RadioGroup';

function RadioButtonDemo() {
  const [value, setValue] = React.useState<string | number>('test-2');

  const handleChange = (e: string | number) => {
    setValue(e);
  };

  return (
    <Container>
      <Container className=" mt-10">
        <Row>
          <Col className="d-flex flex-column">
            <h4>Radio Buttons - Group with no labels</h4>
            <RadioGroup
              name={'no-labels'}
              value={value}
              onChange={handleChange}
            >
              <Radio value={'test-1'} className="mt-6" />
              <Radio value={'test-2'} className="mt-6" />
              <Radio value={'test-3'} className="mt-6" disabled />
            </RadioGroup>
          </Col>
          <Col className="d-flex flex-column">
            <h4>Radio Buttons - Group with labels</h4>
            <RadioGroup
              name={'with-labels'}
              value={value}
              onChange={handleChange}
            >
              <Radio
                value={'test-1'}
                id={'x1'}
                label={'Radio with label'}
                className="mt-6"
              />
              <Radio
                value={'test-2'}
                id={'x2'}
                label={'Radio with label'}
                className="mt-6"
              />
              <Radio
                value={'test-3'}
                id={'x3'}
                label={'Radio with label - disabled'}
                className="mt-6"
                disabled
              />
            </RadioGroup>
          </Col>
          <Col className="d-flex flex-column">
            <h4>Radio Buttons - Stand Alone Radio buttons</h4>
            <Radio
              name={'no-label-selected'}
              value={'test-1'}
              className="mt-6"
              defaultChecked
            />
            <Radio
              name={'no-label-no-selected'}
              value={'test-1'}
              className="mt-6"
            />
            <Radio
              name={'checked'}
              value={'test-2'}
              id={'1x'}
              label={'Radio with label - default'}
              defaultChecked
              className="mt-6"
            />
            <Radio
              name={'checked'}
              value={'test-2'}
              id={'2x'}
              label={'Radio with label - selected'}
              defaultChecked
              className="mt-6"
            />
            <Radio
              name={'disabled-radio'}
              value={'test-3'}
              label={'Radio with label - disabled'}
              className="mt-6"
              disabled
            />
          </Col>
        </Row>
        <div>
          <h4 tabIndex={0}>Radio Buttons</h4>
          <div className="mt-6 d-flex justify-content-between">
            <RadioGroup
              name={'radio-buttons'}
              value={value}
              onChange={handleChange}
            >
              <Radio
                name={'radio-button'}
                value={'10'}
                label={'Radio Button 1'}
                className="mt-6"
                id={'cr-10'}
                isRadioButton
              />
              <Radio
                name={'radio-button'}
                value={'11'}
                label={'Radio Button 2'}
                className="mt-6"
                id={'cr-11'}
                isRadioButton
              />
              <Radio
                name={'radio-button'}
                value={'12'}
                label={'Radio Button 3'}
                className="mt-6"
                id={'cr-12'}
                isRadioButton
              />
            </RadioGroup>
          </div>
        </div>
      </Container>
    </Container>
  );
}

export default RadioButtonDemo;
